<div class="content">
	<div class="col flash scroll-container ">
		<div class="">
			<div class="row">
				<div class="col">
					<div class="row">
						<p class="grey-blue-text text-darken-4"><div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						<div>Hello, gogi</div>

		<div>Hello, gogi</div>
						
						<p>
			
					</div>
					<p class="grey-blue-text text-darken-4">
					<p>
						<authentication />
				</div>
			</div>
		</div>

	</div>
	<div class="col horizontal-scroll-container vi"
		(wheel)="handleVerticalScroll($event)"
		(touchmove)="handleVerticalScroll($event)">
		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>
		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>
		<div>Hello, gogi</div>
		<div>Hello, gogi</div>
		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>
		<div>Hello, gogi</div>
		<div>Hello, gogi</div>
		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>
		<div>Hello, gogi</div>
		<div>Hello, gogi</div>
		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>
		<div>Hello, gogi</div>
		<div>Hello, gogi</div>
		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>
		<div>Hello, gogi</div>
		<div>Hello, gogi</div>
		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>

		<div>Hello, gogi</div>
		<div>Hello, gogi</div>


	</div>
	<div class="rightcomponent scroll-container col">
		<div class="" [dir]="currentDirection">
			<div class="row">
				<div class="col">
					<div class="row">
					<registration />
					<authentication />
				</div>
			</div>
		</div>
	</div>
</div>

